// extracted by mini-css-extract-plugin
export var carouselMiniatures = "otBilleterie-module--carouselMiniatures--bf609";
export var contactSection = "otBilleterie-module--contactSection--0eb50";
export var contactWrapper = "otBilleterie-module--contactWrapper--67937";
export var content = "otBilleterie-module--content--df184";
export var description = "otBilleterie-module--description--cf510";
export var descriptionBlock = "otBilleterie-module--descriptionBlock--9ee8b";
export var grid = "otBilleterie-module--grid--6055a";
export var hidden = "otBilleterie-module--hidden--2026e";
export var hide = "otBilleterie-module--hide--4eeaf";
export var icon = "otBilleterie-module--icon--94ef0";
export var libelle = "otBilleterie-module--libelle--763bb";
export var reviews = "otBilleterie-module--reviews--c2393";
export var widget = "otBilleterie-module--widget--aa189";
export var widgetWrapper = "otBilleterie-module--widgetWrapper--24085";
export var wrapper = "otBilleterie-module--wrapper--5bdc8";